import React from 'react';
import Template from '../../components/expertise/template'

const Energy = ()=> {
    return <Template expertise="energy" id={1} />
}
export default Energy